import { Box, Textarea } from "@mui/joy";
import CommonModal from "../../../../common/CommonModal";
import { colorTokens, textTokens } from "../../../../../styles/globalStyles";

type FullScreenCommentModalProps = {
  open: boolean;
  value: string;
  onValueChange: (value: string) => void;
  onSave: () => void;
  onClose: () => void;
};

export default function FullScreenCommentModal({
  open,
  value,
  onValueChange,
  onSave,
  onClose,
}: FullScreenCommentModalProps) {
  return (
    <CommonModal
      open={open}
      onClose={onClose}
      title="Commentaire de plongée"
      size="md"
      onConfirm={onSave}
      confirmLabel="Enregistrer"
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Textarea
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
          minRows={5}
          maxRows={15}
          sx={{
            flexGrow: 1,
            mb: 2,
            backgroundColor: colorTokens.bg.surfaceMuted,
            color: textTokens.color.primary,
            border: `1px solid ${colorTokens.border.default}`,
          }}
          autoFocus
        />
      </Box>
    </CommonModal>
  );
}
